"use client";
import React from "react";
import { useAuth } from "@/context/AuthContext";

const HomeHero = () => {
  const { user } = useAuth();
  const getStartedHref = user ? "/dashboard" : "/register";
  const getStartedText = user ? "Go to Dashboard" : "Get Started Free";

  return (
    <section className="relative py-10 md:py-32 bg-background flex flex-col items-center justify-center text-center px-4 overflow-hidden">
      <div className="max-w-5xl mx-auto relative z-10">
        <h1 className="text-6xl md:text-8xl font-extrabold tracking-tight text-primary-text mb-8 leading-tight">
          Build Backend Logic. <br className="hidden md:block" />
          Visually.
        </h1>

        <p className="text-xl md:text-2xl text-secondary-text max-w-2xl mx-auto mb-12 font-medium leading-relaxed">
          The ultimate no-code platform for creating, deploying, and managing your backend automation without writing a single line of code.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={getStartedHref}
            className="px-8 py-4 text-lg font-bold rounded-full bg-primary-text text-background hover:opacity-90 transition-all duration-300 shadow-lg min-w-[180px]"
          >
            {getStartedText}
          </a>
          {!user && (
            <a
              href="/dashboard"
              className="px-8 py-4 text-lg font-bold rounded-full bg-transparent border border-border text-primary-text hover:bg-hover-background transition-all duration-300 min-w-[180px]"
            >
              View Demo
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
